(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../components/BlockFormControlLayout"));
	else if(typeof define === 'function' && define.amd)
		define(["../../components/BlockFormControlLayout"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../components/BlockFormControlLayout")) : factory(root["../../components/BlockFormControlLayout"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__662__) {
return 